import { convertListToGridLayoutItem, convertToWidgetGroupValueResponseV8Group } from './widgets';
import type { DashboardWidgetGroupValueV8 } from '@/api-client/metav8Over/model';
import { ViewPackPort } from './view-pack.ports';

const convertToPackType: ViewPackPort['convertToPackType'] = (packType) => {
  switch (packType) {
    case 'PresetPack':
      return 'PresetPack';
    case 'UserPack':
      return 'UserPack';
    default:
      throw new Error(`Unknown packType: ${packType}`);
  }
};

export const convertToViewPackInfo: ViewPackPort['convertToViewPackInfo'] = (viewPackInfo) => {
  const gridLayout = convertListToGridLayoutItem(viewPackInfo.widgets ?? []);
  return {
    name: viewPackInfo.name ?? '',
    description: viewPackInfo.description ?? '',
    packId: viewPackInfo.packId ?? 0,
    widgetMappingId: gridLayout.widgetMappingId ?? -1,
    packType: convertToPackType(viewPackInfo.packType),
    width: gridLayout.w,
    height: gridLayout.h,
    titleOption: gridLayout.titleOption,
    widgetColor: gridLayout.widgetColor,
    widgets: gridLayout,
    createUserName: viewPackInfo.createUserName ?? '',
    createUserRole: viewPackInfo.createUserRole ?? '-1',
    tag: viewPackInfo.tag ?? '',
    image: viewPackInfo.image,
    category: viewPackInfo.category,
    viewPackOptions: viewPackInfo.viewPackOptions,
  };
};

export const convertToWidgetPackRegisterRequestV8: ViewPackPort['convertToWidgetPackRegisterRequestV8'] =
  (viewPackInfo) => {
    return {
      category: viewPackInfo.category,
      description: viewPackInfo.description,
      name: viewPackInfo.name,
      packType: viewPackInfo.packType,
      tag: viewPackInfo.tag,
      image: viewPackInfo.image,
      widgets: convertToWidgetGroupValueResponseV8Group(
        viewPackInfo.widgets,
        null,
      ) as DashboardWidgetGroupValueV8[],
    };
  };
